import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { RedocStandalone } from 'redoc';
import { useIntl } from 'react-intl';
import { useUserRestrictions } from '../auth/user-restrictions';
import { fillPlaceholders, paths, useNavigate } from '../routing';
import { useTeamInfo } from '../team-id-context';
import LoadingSpinner from '../components/loading-spinner';
import { env } from '../config/env';

/**
 * Renders the REST Data API documentation using Redoc, pointing at the
 * server-side OpenAPI spec. Gated behind `hasApiAccess` — Professional users only.
 */
const ApiDocs = () => {
  const { formatMessage } = useIntl();
  const { teamId } = useTeamInfo();
  const navigate = useNavigate();
  const { restrictionsLoading, hasApiAccess } = useUserRestrictions();

  useEffect(() => {
    if (!restrictionsLoading && !hasApiAccess) {
      navigate(fillPlaceholders(paths.deals.landing, { teamId }) + '?upgrade=api_access');
    }
  }, [restrictionsLoading, hasApiAccess, navigate, teamId]);

  if (restrictionsLoading) return <LoadingSpinner />;
  if (!hasApiAccess) return null;

  const specUrl = `${env.API_URL}/api/v1/openapi`;

  return (
    <div style={{ flex: 1, minHeight: 0, overflow: 'auto', width: '100%' }} className="propdocs-api-docs">
      <Helmet title={formatMessage({ id: 'title.api-docs', defaultMessage: 'API Documentation' })} />
      <style>{`
        .propdocs-api-docs a[href*="redocly.com"],
        .propdocs-api-docs a[href*="redoc.ly"] {
          display: none !important;
        }
      `}</style>
      <RedocStandalone
        specUrl={specUrl}
        options={{
          hideDownloadButton: false,
          hideLoading: false,
          disableSearch: false,
          theme: {
            colors: { primary: { main: '#3B7FE2' } },
            typography: {
              fontSize: '14px',
              fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
              headings: { fontFamily: '"Inter", sans-serif', fontWeight: '600' },
            },
            sidebar: { width: '260px' },
          },
          expandResponses: '200,201',
          jsonSampleExpandLevel: 2,
          nativeScrollbars: true,
        }}
      />
    </div>
  );
};

export default ApiDocs;
